import type { StatusTone } from '../components/ui';

const STATUS_TONE_MAP: Record<string, StatusTone> = {
  active: 'active',
  activated: 'active',
  approved: 'active',
  accepted: 'active',
  verified: 'active',
  open: 'active',
  healthy: 'active',
  assigned: 'anchored',
  notified: 'suspicious',
  minted: 'muted',
  created: 'muted',
  suspicious: 'suspicious',
  pending: 'suspicious',
  warning: 'suspicious',
  review: 'suspicious',
  planned: 'muted',
  placeholder: 'muted',
  'in-progress': 'anchored',
  consumed: 'expired',
  recalled: 'recalled',
  revoked: 'recalled',
  rejected: 'recalled',
  failed: 'recalled',
  blocked: 'recalled',
  expired: 'expired',
  disabled: 'disabled',
  inactive: 'disabled',
  anchored: 'anchored',
  blockchain: 'anchored',
  'ai-flagged': 'ai-flagged',
  flagged: 'ai-flagged',
  anomaly: 'ai-flagged',
};

const toTitleCase = (value: string): string =>
  value
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const normalizeStatusToken = (status: string | null | undefined): string =>
  String(status ?? '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-');

export const mapStatusToTone = (
  status: string | null | undefined,
  fallbackTone: StatusTone = 'muted'
): StatusTone => {
  const normalized = normalizeStatusToken(status);
  return STATUS_TONE_MAP[normalized] ?? fallbackTone;
};

export const mapStatusToBadge = (
  status: string | null | undefined,
  fallbackLabel = 'Unknown'
): { tone: StatusTone; label: string } => {
  const normalized = normalizeStatusToken(status);
  const tone = mapStatusToTone(status);
  const label = normalized ? toTitleCase(normalized.replace(/-/g, ' ')) : fallbackLabel;
  return { tone, label };
};
